import { cache } from "react";

const getYear = (date: Date = new Date()) => {
  //if > last day of february, return current year, else return current year - 1
  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();

  if (month > 1 || (month === 1 && day > 28)) {
    return year;
  } else {
    return year - 1;
  }
};

export default getYear;
